// extracted by css-extract-rspack-plugin
export default {"cls1":"LandingScreen-cls1__g5","cls2":"LandingScreen-cls2_Nmk LandingScreen-cls1__g5"};